import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import Link from "../Link";
import Icon from "../Icon";
import { classes } from "../utils/classes";
import { textAlignPropTypes } from "../props/sx";

const Item = ({ icon, active = false, className = "", children, ...props }) => {
	return (
		<Link.Button
			className={classes("pagination__item", active && "pagination__item--active", className)}
			disabled={active}
			{...props}
		>
			{icon === "left" ? (
				<>
					<Icon name="long-arrow-left" />{" "}
				</>
			) : null}
			{children}
			{icon === "right" ? (
				<>
					{" "}
					<Icon name="long-arrow-right" />
				</>
			) : null}
		</Link.Button>
	);
};

Item.propTypes = {
	icon: oneOf(["left", "right"]),
	active: bool,
	className: string,
	children: node.isRequired,
};

const Divider = () => <span className="pagination__divider">...</span>;

const Pagination = ({ align = "center", className = "", children, ...props }) => (
	<div className={classes("pagination", `pagination--${align}`, className)} {...props}>
		{children}
	</div>
);

Pagination.propTypes = {
	align: textAlignPropTypes,
	className: string,
	children: node.isRequired,
};

Pagination.Item = Item;
Pagination.Divider = Divider;

export default Pagination;
